import React from "react";
import { getCreditText, isUserEmployer } from "../../../helpers/common";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const UsersWallet = () => {
  const { profile } = useSelector((state) => state.customer);
  const { planDetails, isPlanLoading } = useSelector((state) => state.employer);

  console.log("PROFILE ROLE:", profile?.role);
  console.log("PROFILE DATA ROLE:", profile?.data?.role);
  console.log("PROFILE@:", profile);
  console.log("PLAN DETAILS:", planDetails);
  console.log("IS LOADING:", isPlanLoading);

  const isUserEmployer = (profile) => {
    return profile?.data?.role === "employer";
  };

  // ADDED: Check if user is an employer. If not, return null (renders nothing)
  if (!isUserEmployer(profile)) {
    return null;
  }

  const creditBalance = planDetails?.balance || 0;
  const hasPlan = planDetails && Object.keys(planDetails).length > 0;
  const isPlanExpired = planDetails?.isExpired || false;
  const shouldRedirectToPricing = !hasPlan || creditBalance === 0;

  console.log("CREDIT BALANCE:", creditBalance);
  console.log("HAS PLAN:", hasPlan);
  console.log("PLAN EXPIRED:", isPlanExpired);
  console.log("REDIRECT TO PRICING:", shouldRedirectToPricing);

  const getWalletContent = () => {
    console.log("RUNNING getWalletContent");

    if (isPlanLoading) {
      console.log("STATE: LOADING");
      return (
        <div className="d-flex flex-column">
          <div className="bg-white bg-opacity-75" style={{ width: "25px", height: "12px" }}></div>
          <div className="bg-white bg-opacity-75" style={{ width: "35px", height: "8px", marginTop: "2px" }}></div>
        </div>
      );
    }

    if (!hasPlan) {
      console.log("STATE: NO PLAN");
      return (
        <div className="d-flex flex-column">
          <span className="fw-bold text-white">No Plan</span>
          <span className="text-light">Get Started</span>
        </div>
      );
    }

    if (isPlanExpired) {
      console.log("STATE: EXPIRED");
      return (
        <div className="d-flex flex-column">
          {/* <span className="fw-bold text-white">{creditBalance}</span> */}
          <span className="fw-bold text-white">Plan</span>
          <span className="text-light">Expired</span>
        </div>
      );
    }

    console.log("STATE: ACTIVE PLAN");

    return (
      <div className="d-flex flex-column">
        <span className="fw-bold text-light">{creditBalance}</span>
        <span className="text-light">Credits left</span>
      </div>
    );
  };

  const getBackgroundClass = () => {
    console.log("CHECKING BACKGROUND CLASS");

    if (isPlanLoading) return "wallet-icon-loading";
    if (!hasPlan || creditBalance === 0 || isPlanExpired) return "bg-danger";
    return "";
  };

  return (
    <li className="position-relative ms-1 me-3 h-100 d-none d-sm-block">
      <Link
        className="primary-link fs-13"
        to={shouldRedirectToPricing ? "/pricing" : "/employer/orders"}
      >
        <div className={`d-flex align-items-center wallet-icon ${getBackgroundClass()}`}>
          <i className="mdi mdi-wallet"></i>
          <span className="ms-2">{getWalletContent()}</span>
        </div>
      </Link>
    </li>
  );
};

export default UsersWallet;
